module.exports = __webpack_public_path__ + "static/media/baseline-chevron_left-24px.7e77da69.svg";